import React from 'react';
import { Shield, Sparkles, Award, Heart } from 'lucide-react';
export const TrustSection = () => {
  const trustBadges = [{
    icon: Sparkles,
    title: 'Cleaned & Sanitized',
    description: 'Every piece is thoroughly cleaned and sanitized after each use'
  }, {
    icon: Shield,
    title: 'Fully Insured',
    description: 'We carry comprehensive liability insurance for your peace of mind'
  }, {
    icon: Award,
    title: 'Safety Certified',
    description: 'All equipment meets or exceeds safety standards for toddlers'
  }, {
    icon: Heart,
    title: 'Parent Approved',
    description: 'Trusted by hundreds of Atlanta families for safe, fun play'
  }];
  return <section className="bg-primary-50 py-16 md:py-20" data-id="element-480">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-481">
        <div className="text-center mb-12" data-id="element-482">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-gray-900 mb-4" data-id="element-483">
            Safe, Clean & Trusted
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-484">
            Your child's safety and happiness are our top priorities
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-485">
          {trustBadges.map((badge, index) => <div key={index} className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow text-center" data-id="element-486">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-primary-100 rounded-full mb-4" data-id="element-487">
                <badge.icon className="w-8 h-8 text-primary-600" strokeWidth={2} data-id="element-488" />
              </div>
              <h3 className="text-lg font-heading font-bold text-gray-900 mb-2" data-id="element-489">
                {badge.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed" data-id="element-490">
                {badge.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
};